<rask-page pageTitle="Jobb detaljer" noPadding>
    <rask-container-block>
        <div class="row">
            <rask-input-number class="col-1" label="Antal försök" infoText="Ange ett antal som kommer gälla för alla jobb vid status förändring" [(ngModel)]="antalForsok" aid="antalforsok"></rask-input-number>
        </div>
        <rask-list
        #jobbdetails
        [data]="jobbDetailList"
        [rowSelectable]="true"
        [useClientFilter]="true"
        clientFilterResultText="jobb"
        (checkedChanged)="onCheckedChange()">
            <rask-list-column header="Typ" field="typ" [sortable]="true"></rask-list-column>
            <rask-list-column header="Antal försök" field="antalForsok"></rask-list-column>
            <rask-list-column header="Nyckel" field="nyckel"></rask-list-column>
            <rask-list-column header="Meddelande" field="meddelande"></rask-list-column>
            <rask-list-column header="Data" field="data"></rask-list-column>
        </rask-list>
    </rask-container-block>
    <ng-container footerContent>
        <rask-button aid="buttonNy" color="primary" (click)="uppdateraStatus('Ny')" [disabled]="!canChangeStatus()">Satt status till Ny</rask-button>
        <rask-button aid="buttonIgnorerad" color="primary" (click)="uppdateraStatus('Ignorerad')" [disabled]="!canChangeStatus()">Satt status till Ignorerad</rask-button>
    </ng-container>
</rask-page>

